import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "../../../../../CustomHeadlessTable/CustomTable";
import {
  getWaterLocationalEquipment,
  getWaterSymbioticEquipment,
  addWaterToBusiness,
  updateWaterEquipment,
  deleteWater,
} from "../../../../../../apis/Business/EnergyApi";
import {
  getWaterSourceData,
  getWaterCompanyDropdown,
} from "../../../../../../apis/Dropdown";
import CustomInputComponent from "../../../../../CustomHeadlessTable/components/CustomInputComponent";
import { getTransportCountryData } from "../../../../../../apis/Dropdown";

const WaterEquipmentTable = ({ businessId, category }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownBy, setDropdownBy] = useState([]);
  const [dropdownLocation, setDropdownLocation] = useState([]);
  const [unitMaterials, setUnitMaterials] = useState({});

  const [dropdownUsedFor, setDropdownUsedFor] = useState([
    {
      id: 1,
      name: t("WATER_METERS"),
      value: t("WATER_METERS"),
      type: t("WATER_METERS"),
      unit: "kg",
      typeDB: "water_meters",
      key: "WATER_METERS",
    },
    {
      id: 2,
      name: t("PIPES"),
      value: t("PIPES"),
      type: t("PIPES"),
      unit: "L",
      typeDB: "pipes",
      key: "PIPES",
    },
    {
      id: 3,
      name: t("PUMPS"),
      value: t("PUMPS"),
      type: t("PUMPS"),
      unit: "L",
      typeDB: "Pumps",
      key: "PUMPS",
    },
    {
      id: 4,
      name: t("TANKS"),
      value: t("TANKS"),
      type: t("TANKS"),
      unit: "L",
      typeDB: "tanks",
      key: "TANKS",
    },
    {
      id: 5,
      name: t("PURIFIERS"),
      value: t("PURIFIERS"),
      type: t("PURIFIERS"),
      unit: "L",
      typeDB: "purifiers",
      key: "PURIFIERS",
    },
    {
      id: 6,
      name: t("HEATERS"),
      value: t("HEATERS"),
      type: t("HEATERS"),
      unit: "L",
      typeDB: "heaters",
      key: "HEATERS",
    },
    {
      id: 7,
      name: t("SOFTENERS"),
      value: t("SOFTENERS"),
      type: t("SOFTENERS"),
      unit: "L",
      typeDB: "softeners",
      key: "SOFTENERS",
    },
    {
      id: 8,
      name: t("INSULATION"),
      value: t("INSULATION"),
      type: t("INSULATION"),
      unit: "L",
      typeDB: "insulation",
      key: "INSULATION",
    },
    {
      id: 9,
      name: t("ELECTRICAL_COMP"),
      value: t("ELECTRICAL_COMP"),
      type: t("ELECTRICAL_COMP"),
      unit: "L",
      typeDB: "electrical_comp",
      key: "ELECTRICAL_COMP",
    },
    {
      id: 10,
      name: t("PLASTIC_COMP"),
      value: t("PLASTIC_COMP"),
      type: t("PLASTIC_COMP"),
      unit: "L",
      typeDB: "platic_comp",
      key: "PLASTIC_COMP",
    },
  ]);

  const toggleColumnVisibility = useCallback((columnId) => {
    setHiddenColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId)
        : [...prev, columnId]
    );
  }, []);

  useEffect(() => {
    setDropdownUsedFor([
      {
        id: 1,
        name: t("WATER_METERS"),
        value: t("WATER_METERS"),
        type: t("WATER_METERS"),
        unit: "kg",
        typeDB: "water_meters",
        key: "WATER_METERS",
      },
      {
        id: 2,
        name: t("PIPES"),
        value: t("PIPES"),
        type: t("PIPES"),
        unit: "L",
        typeDB: "pipes",
        key: "PIPES",
      },
      {
        id: 3,
        name: t("PUMPS"),
        value: t("PUMPS"),
        type: t("PUMPS"),
        unit: "L",
        typeDB: "Pumps",
        key: "PUMPS",
      },
      {
        id: 4,
        name: t("TANKS"),
        value: t("TANKS"),
        type: t("TANKS"),
        unit: "L",
        typeDB: "tanks",
        key: "TANKS",
      },
      {
        id: 5,
        name: t("PURIFIERS"),
        value: t("PURIFIERS"),
        type: t("PURIFIERS"),
        unit: "L",
        typeDB: "purifiers",
        key: "PURIFIERS",
      },
      {
        id: 6,
        name: t("HEATERS"),
        value: t("HEATERS"),
        type: t("HEATERS"),
        unit: "L",
        typeDB: "heaters",
        key: "HEATERS",
      },
      {
        id: 7,
        name: t("SOFTENERS"),
        value: t("SOFTENERS"),
        type: t("SOFTENERS"),
        unit: "L",
        typeDB: "softeners",
        key: "SOFTENERS",
      },
      {
        id: 8,
        name: t("INSULATION"),
        value: t("INSULATION"),
        type: t("INSULATION"),
        unit: "L",
        typeDB: "insulation",
        key: "INSULATION",
      },
      {
        id: 9,
        name: t("ELECTRICAL_COMP"),
        value: t("ELECTRICAL_COMP"),
        type: t("ELECTRICAL_COMP"),
        unit: "L",
        typeDB: "electrical_comp",
        key: "ELECTRICAL_COMP",
      },
      {
        id: 10,
        name: t("PLASTIC_COMP"),
        value: t("PLASTIC_COMP"),
        type: t("PLASTIC_COMP"),
        unit: "L",
        typeDB: "platic_comp",
        key: "PLASTIC_COMP",
      },
      {
        id: 11,
        name: t("VALVE"),
        value: t("VALVE"),
        type: t("VALVE"),
        unit: "L",
        typeDB: "valve",
        key: "VALVE",
      },
    ]);
  }, [t]);

  const filteredNicknames = useMemo(() => {
    return dropdownBy && dropdownBy.length > 0
      ? dropdownBy.flatMap((item) =>
          item.value.map((nickname) => ({
            title: nickname,
            value: nickname,
          }))
        )
      : [];
  }, [dropdownBy]);

  const fetchData = useCallback(() => {
    category === "found"
      ? getWaterLocationalEquipment({
          businessId,
          setObjects: setData,
        })
      : getWaterSymbioticEquipment({
          businessId,
          setObjects: setData,
        });
    getWaterSourceData({ setDropdownWaterData: setDropdownData });
    getWaterCompanyDropdown({
      setNicknameDropdown: setDropdownBy,
      id: businessId,
    });
    getTransportCountryData({
      setDropdownData: setDropdownLocation,
    });
  }, [businessId, category]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (data.length > 0 && dropdownData?.length > 0) {
      const newUnitMaterials = {};
      data.forEach((row) => {
        const materialValue =
          row["materials.value"]?.value || row.materials?.value;

        if (materialValue) {
          const selectedMaterial = dropdownData.find(
            (option) =>
              option?.material_name === materialValue ||
              option?.material_name_en === materialValue
          );

          if (selectedMaterial) {
            newUnitMaterials[row.id] = selectedMaterial.unit;
          }
        }
      });
      setUnitMaterials(newUnitMaterials);
    }
  }, [data, dropdownData]);

  const dynamicPlaceholders = useMemo(
    () => ({
      "materials.value": {
        targetField: "weight",
        getPlaceholder: (
          selectedValue,
          dropdownData,
          rowData,
          rowId = "new"
        ) => {
          const selectedMaterial = dropdownData?.find(
            (option) =>
              option?.material_name === selectedValue ||
              option?.material_name_en === selectedValue
          );
          if (selectedMaterial) {
            if (rowId !== "new") {
              setUnitMaterials((prev) => ({
                ...prev,
                [rowId]: selectedMaterial.unit,
              }));
            } else {
              setUnitMaterials((prev) => ({
                ...prev,
                new: selectedMaterial.unit,
              }));
            }
          }
        },
        dropdownDataKey: "materials.value",
      },
    }),
    []
  );

  const handleEdit = useCallback(
    (editedItem) => {
      let typeObj = {};
      if (editedItem["type_equipment.value"]) {
        typeObj = dropdownUsedFor.find(
          (item) => item.value === editedItem["type_equipment.value"].value
        );
      } else if (editedItem["type_equipment"].value) {
        typeObj = dropdownUsedFor.find(
          (item) => item.value === editedItem["type_equipment"].value
        );
      }

      const typedb =
        typeObj && typeObj.typeDB
          ? typeObj.typeDB
          : editedItem.type && typeof editedItem.type === "string"
          ? editedItem.type
          : data["typedb_water"];
      updateWaterEquipment({
        businessId,
        objectId: editedItem.id,
        ...editedItem,
        category: category,
        subcategory: "equipment_locational",
        type_equipment: editedItem["type_equipment.value"]
          ? editedItem["type_equipment.value"].value
          : editedItem["type_equipment"]
          ? editedItem["type_equipment"].value
          : null,
        materials: editedItem["materials.value"]
          ? editedItem["materials.value"].value
          : editedItem["materials"]
          ? editedItem["materials"].value
          : null,
        nickname: editedItem["nickname.value"]
          ? editedItem["nickname.value"].value
          : editedItem["nickname"]
          ? editedItem["nickname"].value
          : null,
        typeDBWater: typedb,
        invoiceDate: editedItem["invoice_date"],
        invoiceNo: editedItem["invoice_number"],
        production_country: editedItem["production_country.value"]
          ? editedItem["production_country.value"].value
          : editedItem["production_country"]
          ? editedItem["production_country"].value
          : null,
        objects: data,
        setObjects: setData,
        use_swal: true,
      });
    },
    [businessId, dropdownUsedFor, data, setData, category]
  );

  const handleAdd = useCallback(
    (newItem) => {
      let typeObj = {};
      if (newItem["type_equipment.value"]) {
        typeObj = dropdownUsedFor.find(
          (item) => item.value === newItem["type_equipment.value"].value
        );
      }
      addWaterToBusiness({
        businessId,
        ...newItem,
        category: category,
        subcategory: "equipment_locational",
        type_equipment: newItem["type_equipment.value"]
          ? newItem["type_equipment.value"].value
          : null,
        materials: newItem["materials.value"]
          ? newItem["materials.value"].value
          : null,
        nickname: newItem["nickname.value"]
          ? newItem["nickname.value"].value
          : null,
        typeDBWater: typeObj ? typeObj.typeDB : newItem.type,
        invoiceDate: newItem["invoice_date"],
        invoiceNo: newItem["invoice_number"],
        production_country: newItem["production_country.value"]
          ? newItem["production_country.value"].value
          : null,
        callback: fetchData,
        use_swal: true,
      });
    },
    [businessId, dropdownUsedFor, fetchData, category]
  );

  const handleDelete = useCallback(
    (itemToDelete) => {
      deleteWater({
        businessId,
        objectId: itemToDelete.id,
        callback: fetchData,
      });
    },
    [businessId, fetchData]
  );

  const columns = useMemo(
    () => [
      {
        accessor: "invoice_date",
        header: t("INVOICE_DATE"),
        type: "text",
        canHide: true,
        canSort: true,
        placeholder: t("DD_MM_YYYY"),
        optional: true,
        width: "80px",
      },
      {
        accessor: "invoice_number",
        header: t("INVOICE_NO"),
        type: "text",
        canSort: true,
        canHide: true,
        optional: true,
        width: "80px",
      },
      {
        accessor: "type_equipment.value",
        header: `${t("EQUIPMENT")}*`,
        type: "dropdown",
        dropdownData: dropdownUsedFor,
        disableSortBy: true,
        tipHeader: "Tip",
        tipBody: t("TIP_WATER_LOC_1"),
        width: "120px",
      },
      {
        accessor: "nickname.value",
        header: `${t("WATER_EQUIPMENT")}*`,
        type: "dropdown",
        dropdownData: filteredNicknames,
        disableSortBy: true,
        width: "120px",
        tipHeader: "Tip",
        tipBody: t("TIP_WATER_LOC_2"),
      },
      {
        accessor: "materials.value",
        header: `${t("MATERIAL_SINGULAR")}*`,
        type: "dropdown",
        dropdownData: dropdownData,
        disableSortBy: true,
        tipHeader: "Tip",
        tipBody: t("TIP_WATER_LOC_3"),
        width: "120px",
      },
      {
        accessor: "weight",
        header: (props) => {
          const rowId = props.row?.original?.id;
          return `${t("QUANTITY")}* (${unitMaterials[rowId] || "xx"})`;
        },
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "80px",
        unit: (rowId) => `${unitMaterials[rowId] || "xx"}`,
      },
      {
        accessor: "production_country.value",
        header: t("PURCHASED_FROM"),
        type: "dropdown",
        dropdownData: dropdownLocation,
        disableSortBy: true,
        width: "110px",
        optional: true,
      },
      {
        accessor: "manuel",
        header: t("MANUEL"),
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "80px",
        optional: true,
        tipHeader: "Tip",
        tipBody: t("TIP_WATER_LOC_4"),
      },
      {
        accessor: "spacer1",
        header: "",
        type: "spacer",
        width: "20px",
        optional: true,
        disableSortBy: true,
      },
      {
        accessor: "price_invoice",
        header: t("PRICE_INVOICE"),
        type: "number",
        canSort: true,
        canHide: true,
        placeholder: "0",
        optional: true,
        subtotalUnit: "DKK",
        width: "80px",
        tipHeader: "Tip",
        tipBody: t("PRICE_INVOICE_TIP"),
      },
      {
        accessor: "carbon",
        header: t("CARBON_OUTPUT"),
        type: "custom",
        canSort: true,
        cell: ({ value }) => {
          return <CustomInputComponent value={value} readOnly />;
        },
        optional: true,
        subtotalUnit: "tCO₂e",
        subtotalFixed: true,
        width: "80px",
      },
    ],
    [
      dropdownUsedFor,
      dropdownData,
      filteredNicknames,
      dropdownLocation,
      unitMaterials,
      t,
    ]
  );

  const disableRules = {
    carbon: () => true,
  };

  const subtotalColumns = {
    price_invoice: { label: t("TOTAL_PRICE") },
    carbon: { label: t("TOTAL_CARBON") },
  };

  const memoizedDropdownData = useMemo(
    () => ({
      "type_equipment.value": dropdownUsedFor,
      "nickname.value": filteredNicknames,
      "materials.value": dropdownData,
      "production_country.value": dropdownLocation,
    }),
    [dropdownUsedFor, filteredNicknames, dropdownData, dropdownLocation]
  );

  return (
    <CustomTable
      columns={columns}
      data={data}
      setData={setData}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      dropdownData={memoizedDropdownData}
      customInputs={{ carbon: CustomInputComponent }}
      hiddenColumns={hiddenColumns}
      toggleColumnVisibility={toggleColumnVisibility}
      subtotalColumns={subtotalColumns}
      disableRules={disableRules}
      dynamicPlaceholders={dynamicPlaceholders}
    />
  );
};

export default WaterEquipmentTable;
